import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatHeading } from '@blocks-react/components/Heading';
export const MyEquipmentSerialPrefix = ({ prefixLabel, suggestions }) => {
    return (_jsxs(CatHeading, { variant: "footnote", children: [_jsx("span", { className: "me-1", children: prefixLabel }), _jsx("span", { className: "fw-bold", children: suggestions })] }));
};
